import '../../../../Assets/app.base';
import GMaps from 'gmaps';

import './MultipleEvents.scss';

// Components
//import '../../../../Components/SocialShare';
import '../../../../Components/Carousel';
import '../../../../Components/EventList';

// Controller
window.compositorApp.controller('ThemedMultipleEventsViewController', ['$scope', function ($scope) {
    var compositeAppInit = window.compositeAppInit;
    var themedEventDetailsControllerInit = window.themedEventDetailsControllerInit;

    $scope.viewLargeMap = function () {
        if (compositeAppInit.IsMobile) {
            var url = window.currentGMapsTargetUrl || "https://maps.google.com";
            var win = window.open(url, '_blank');
            win.focus();
        } else {
            $('#large-map-modal').modal();
        }
    };

    $scope.showImageView = function (id, date, theme, isPreloaded) {
        $('#pa-imageview').modal();
        $('#pa-imageview').on('hide.bs.modal', function () { });

        window.showImageWithId(id, date, theme);
    };

    window.showImageWithId = function (id, date, theme) {
        $('#pa-imageview-spinner').show();
        $('#pa-imageview-spinner').spin(
            {
                lines: 11,
                length: 4,
                width: 2,
                radius: 4,
                color: '#fff'
            });
        $.get(themedEventDetailsControllerInit.ViewPopularPartyphotoPreviewUrl, {
            token: compositeAppInit.AccessToken,
            id: id,
            date: date,
            theme: theme,
        }).done(function (data) {
            $('#pa-imageview-content').empty();
            $('#pa-imageview-content').append(data);

            $('#pa-imageview-spinner').stop();
            $('#pa-imageview-spinner').hide();
        });
    };

    $('a.viewLargeMapBtn').click($scope.viewLargeMap);

    $('.flyer-item').flexslider(
        {
            smoothHeight: true,
            pauseOnAction: true,
            pauseOnHover: true,
            slideshowSpeed: 6000,
            after: function (slider) {
                //! Causes rendering error (image not visible, white blank space).
                //var items = $('.flyer-item .slides li img');
                //$('.slides').height(items.eq(slider.currentSlide).height());
            },
            start: function () {
                themedEventDetailsControllerInit.PostLoadAdv();
            }
        });

    if (themedEventDetailsControllerInit.IsPreview) {
        $('.ev-list-btn').click(function (e) {
            e.preventDefault();
        });
        $('.ev-list-btn').popover(
            {
                title: 'Vorschau',
                content: 'Da es sich hier um eine Vorschau handelt, ist der Button inaktiv. Sobald Dein Event freigegeben wurde, können die User diesen Dienst nutzen',
                html: true,
                placement: 'top'
            });
    }

    if ($('#location-pictures-container')) {
        $scope.createAdjustedImageMontage('#location-pictures-container', {
            liquid: true,
            margin: 3,
            fillLastRow: false,
            alternateHeight: false
        });
    }
    if ($('#popular-pictures-container')) {
        $scope.createAdjustedImageMontage('#popular-pictures-container', {
            liquid: true,
            margin: 3,
            fillLastRow: false,
            alternateHeight: false
        });
        $('#popular-pictures-container a').click(function (e) {
            e.preventDefault();
            var id = $(this).data('id');
            var date = $(this).data('date');
            var theme = $(this).data('theme');
            $scope.showImageView(id, date, theme, false);
        });
    }

    $scope.importMapsLibrary(function () {
        var url = GMaps.staticMapURL(
            {
                size: [232, 232],
                lat: themedEventDetailsControllerInit.Lat,
                lng: themedEventDetailsControllerInit.Lng,
                zoom: 14,
                markers: [
                    {
                        lat: themedEventDetailsControllerInit.Lat,
                        lng: themedEventDetailsControllerInit.Lng
                    }]
            });

        var urlLatLng = new google.maps.LatLng({
            lat: themedEventDetailsControllerInit.Lat,
            lng: themedEventDetailsControllerInit.Lng,
        });

        window.currentGMapsTargetUrl = "https://maps.google.com/maps?q=loc:" + urlLatLng.toUrlValue();

        $('#region-map').attr('src', url);
        $('#large-map-modal').on('shown.bs.modal', function () {
            var map = new GMaps(
                {
                    div: '#map-large',
                    lat: themedEventDetailsControllerInit.Lat,
                    lng: themedEventDetailsControllerInit.Lng
                });
            map.addMarker(
                {
                    lat: themedEventDetailsControllerInit.Lat,
                    lng: themedEventDetailsControllerInit.Lng,
                    title: themedEventDetailsControllerInit.LocationName
                });

            themedEventDetailsControllerInit.directionsService = new google.maps.DirectionsService();
            themedEventDetailsControllerInit.directionsDisplay = new google.maps.DirectionsRenderer();
            themedEventDetailsControllerInit.directionsDisplay.setMap(map.map);
        });

        $('#current-position').click(function (event) {
            event.preventDefault();
            GMaps.geolocate(
                {
                    success: function (position) {
                        $('#route_start').val(position.coords.latitude + ', ' + position.coords.longitude);
                    }
                });
        });

        $('#calc_route').click(function (event) {
            event.preventDefault();
            var request = {
                origin: $('#route_start').val(),
                destination: themedEventDetailsControllerInit.LocationDestination,
                travelMode: google.maps.TravelMode.DRIVING
            };
            themedEventDetailsControllerInit.directionsService.route(request, function (result, status) {
                if (status == google.maps.DirectionsStatus.OK) {
                    themedEventDetailsControllerInit.directionsDisplay.setDirections(result);
                }
            });
        });
    });
}]);